import React from "react";
import HeroSection from "./HeroSection/HeroSection";
import CardsSection from "./CardsSection/CardsSection";
import ReceviedScholarships from "./ReceviedScholarships/ReceviedScholarships";
import FAQs from "./FAQs/FAQs";
import Banner1 from "./Banner1/Banner1";
import VideoTestimonials from "../PST/VideoTestimonials";

const ScholarshipPage: React.FC = (props: any) => {
  const scholarshipData = props?.pageData ?? {};
  const topScholarships = props?.pageData?.topScholarships ?? {};
  const countryCardsData = props?.pageData?.countryCards ?? {};
  const countrySpecificScholarshipsData = props?.countrySpecificScholarshipsData ?? {};
  const faqData = props?.pageData?.faq ?? {};
  const bannerData = props?.pageData?.banner ?? {};

  const hasData = (obj: object) => Object.keys(obj).length > 0;

  return (
    <>
      <HeroSection scholarshipData={scholarshipData} />
      {hasData(countryCardsData) && (
        <CardsSection scholarshipData={scholarshipData} countryCardsData={countryCardsData} countrySpecificScholarshipsData={countrySpecificScholarshipsData} />
      )}
      {hasData(topScholarships) && <ReceviedScholarships topScholarships={topScholarships} />}
      {props.pageData?.videoTestimonial && (
        <div style={{ marginBottom: "-30px" }}>
          <VideoTestimonials {...props.pageData.videoTestimonial} />
        </div>
      )}
      {hasData(faqData) && <FAQs faqData={faqData} />}
      {hasData(bannerData) && <Banner1 bannerData={bannerData} />}
    </>
  );
};

export default ScholarshipPage;
